const getPercentage = (value: number, total: number) => {
  return Math.round(((value || 0) / (total || 1)) * 100);
};

const convertDecimalToPercentage = (value: number) => {
  return Math.round((value || 0) * 100);
};

export { getPercentage, convertDecimalToPercentage };
